import { fetchPropertyDetails } from "../service/apiService";
import { FormValues, SchedulerConfig } from "../Interface/scheduler/form";
import {
  WDG_FORM_VALUES_HOW_YOU_COUNT_SQFT_KEY,
  WDG_GUTTER_PROPERTY_SIZE,
  WDG_HOLIDAY_LIGHTING_PROPERTY_SIZE,
  WDG_PROPERTY_FLOORS,
} from "../feature/quotation/Constants/constants";
import { MLY_IDS } from "../constants/constant";

const fetchDetails = async (
  formValues: FormValues,
  setFormValues: React.Dispatch<React.SetStateAction<FormValues>>,
  formConfig: SchedulerConfig,
  setIsLoading: (loading: boolean) => void
) => {
  if (!formValues.city || !formValues.state) {
    return;
  }
  setIsLoading(true);
  try {
    // Prepare all required params from formValues
    const houseNumber = String(formValues.houseNumber || "");
    const streetAddress = String(formValues.street || "");
    const city = String(formValues.city || "");
    const state = String(formValues.state || "");
    const zip = String(formValues.zipcode || "");
    const country = String(formValues.countryCode || "");
    const vendorId = String(formValues.vendorId || formConfig.vendorId);

    if (!formValues.attomAPIDataReceived) {
      const propertyResponse = await fetchPropertyDetails(
        houseNumber,
        streetAddress,
        city,
        state,
        zip,
        country,
        vendorId
      );

      const propertyDetails = propertyResponse?.building;
      const sqFt = propertyDetails?.size?.livingSize || "";
      const floors = propertyDetails?.summary?.levels || "";
      const bathRooms = String(propertyDetails?.rooms?.bathsFull) || "";
      const bedRooms = String(propertyDetails?.rooms?.beds) || "";
      if (sqFt) {
        setFormValues((prevValues) => ({
          ...prevValues,
          [WDG_FORM_VALUES_HOW_YOU_COUNT_SQFT_KEY]: String(sqFt),
          [WDG_GUTTER_PROPERTY_SIZE]: String(sqFt),
          [WDG_HOLIDAY_LIGHTING_PROPERTY_SIZE]: String(sqFt),
          [WDG_PROPERTY_FLOORS]: String(floors),
          attomAPIData: String(sqFt),
          attomAPIDataReceived: true,
          [MLY_IDS.MLY_HOME_PROPERTY_SQ_FT]: String(sqFt),
          [MLY_IDS.MLY_OFFICE_PROPERTY_SQ_FT]: String(sqFt),
          [MLY_IDS.MLY_RES_BEEDROOMS]: bedRooms,
          [MLY_IDS.MLY_RES_BATHROOMS]: bathRooms,
          [MLY_IDS.MLY_COM_OFFICES]: bedRooms,
          [MLY_IDS.MLY_COM_BATHROOMS]: bathRooms,
        }));
      }
    }
  } catch (error) {
    console.error("Error fetching property details:", error);
  } finally {
    setIsLoading(false);
  }
};

export default fetchDetails;
